import { Navigate } from "react-router-dom"
import routePaths from "../constants/path"
import { useAuth } from "../hooks/useAuth"
import { isOtpVerified } from "../utils"
import Forbidden from "./Forbidden"
import { intersection } from "lodash"

const ProtectedRoute = ({ component, otpVerified, whoCanAccess }) => {
  const { user } = useAuth()
  const otpVerification = isOtpVerified()

  if (user?.userId && intersection(whoCanAccess, user?.role).length === 0) {
    return <Forbidden />
  }

  return (user?.userId && otpVerified && otpVerification) ||
    (!otpVerified && user?.userId) ? (
    <>{component}</>
  ) : (
    <Navigate replace to={routePaths.login} />
  )
}

export default ProtectedRoute
